<template>
	<div>
		<k-autocomplete v-model="selected" :label="label" :clearable="clearable" :placeholder="placeholder" :items="events" :item-text="title" item-value="uuid" @change="emit_change">
			<template v-slot:selection="data">
				<div>{{data.item.cached_start_time | format_date}} - {{data.item.cached_start_time | format_time}}: {{title(data.item)}}</div>
			</template>
			<template v-slot:item="data">
				<div>{{data.item.cached_start_time | format_date}} - {{data.item.cached_start_time | format_time}}: {{title(data.item)}}</div>
			</template>
		</k-autocomplete>
	</div>
</template>
<script>

import EventModel from '@/models/event.js'
import datelib from '@/lib/date.js';

export default {
	props: {
		"value": {
			type: String,
			default: ""
		}, 
		"filters": {
			type: Object,
			default: {}
		},
		"filter-function": {
			type: Function,
			default: function(events) { return events;}
		},
		"label": {
			type: String,
			default: "Select event"
		},
		"placeholder": {
			type: String,
			default: "Select event"
		},
		"clearable": {
			type: Boolean,
			default: true
		}
	},
  filters: {
    ...datelib
  },
	data () {
		var ch = this.$cloudserver.channel("events:all");
		return {
			ws_channel: ch,
			events: [],
			selected: this.value
		}
	},
	watch: {
		"filters": function(newVal, oldVal) {
			this.filter_events(newVal);
		}
	},
	methods: {
		emit_change () {
			this.$emit("input", this.selected);
		},
		title(event) {
			return EventModel.title(event);
		},
		subtitle(event) {
			return EventModel.subtitle(event);
		},
		filter_events(filters) {
			var self = this;
			var s_filters = _.cloneDeep(filters);

			// Annetaan vaan 100 eventtiä ettei vahingossa voi hakea kaikkia....
			s_filters["limit"] = 100;

			this.ws_channel.push("filter_reply", s_filters)
			.receive("ok", (msg) => {
      	self.events = this.filterFunction(msg.events);
      })
      .receive("error", (msg) => {
				console.log("Event filter failed");
			});
		}
	},
	computed: {

	},
	mounted() {
		this.ws_channel.join();
		this.filter_events(this.filters);
	}

}
</script>